import { createAuthClient } from "better-auth/react";

const baseURL = 'https://api.dbdesign.io:3000/';
// const baseURL = 'http://localhost:3003/';

export const authClient = createAuthClient({ baseURL });
